<script setup>
import { useTranslations } from '@/composables/translations'

const { translate } = useTranslations()

const props = defineProps({
    amount: {
        type: String,
        required: true,
    },
    price_description: {
        type: String,
        required: false,
        default: '',
    },
});
</script>

<template>
    <div class="text-nowrap text-end">
        <p class="m-0">{{ amount }}</p>
        <p class="m-0" v-if="price_description" style="font-size: 12px;">{{ price_description }}</p>
    </div>
</template>

<style lang="scss" type="text/scss" scoped></style>
